package br.com.htms.inspeccaocampo.platform

data class PhotoStampData(
    val tstResponsavel: String,
    val pergunta: String,
    val resposta: String,
    val responsavelFrente: String,
    val localTexto: String,
    val dataHoraMs: Long,
    val latitude: Double?,
    val longitude: Double?,
    val numeroInspecao: Long? = null,
    val rotuloResponsavel: String = "TST"
)

data class ImageSize(val width: Int, val height: Int)

expect object PlatformImage {
    /**
     * Aplica carimbo de texto sobre a foto (JPEG) no próprio arquivo.
     * @return bytes JPEG carimbados, ou null se falhou.
     *         Na Web o PDF depende desses bytes (Base64 no form) — não só do path.
     */
    suspend fun applyStamp(path: String, dados: PhotoStampData): ByteArray?

    fun imageSize(bytes: ByteArray): ImageSize?

    /**
     * Converte PNG/JPEG bytes para JPEG (para PDF/Excel).
     * @param flattenRgb fundo 0xRRGGBB sob pixels transparentes (null = branco).
     *   Use navy do banner (#021B3D) ao embutir PNG com alpha no PDF.
     * @param maxEdgePx maior lado após reencode (export usa 1280; carimbo/geral 1600).
     * @param forceReencode se true, reencoda mesmo já sendo JPEG (export mais leve).
     */
    suspend fun toJpegBytes(
        bytes: ByteArray,
        quality: Float = 0.9f,
        flattenRgb: Int? = null,
        maxEdgePx: Int = 1600,
        forceReencode: Boolean = false
    ): ByteArray?

    /**
     * JPEG da assinatura com margem branca removida (só a tinta).
     * Fallback: [toJpegBytes].
     */
    suspend fun toSignatureJpegBytes(bytes: ByteArray, quality: Float = 0.92f): ByteArray?

    /** Solicita permissões de câmera/localização (no-op se já concedidas). */
    suspend fun requestPermissions(): Boolean
}
